import axios from '@axios';
// import HelperService from '@/services/HelperService';

// const helperService = new HelperService();
const base = '/api/v1/offsite-users';

export default {
  login(email, password) {
    return axios.post(`${base}/tokens`, { email, password });
  },
  getUser() {
    return axios.get(`${base}/user`);
  },
  requestPasswordReset(email) {
    return axios.post(`${base}/request-password-reset`, { email });
  },
  resetPassword(email, passwordResetToken, newPassword) {
    return axios.post(`${base}/reset-password`, { email, passwordResetToken, newPassword });
  },
};
